/* globals: YMK */

import React from 'react';

import * as constants from '../components/Constants'
import { PlausibleState } from '../components/PlausibleState'


// 24
import shade1 from '../assets/Images/VTO/SWATCHES/100-Posie-K-Swatch.png'
// 25
import shade2 from '../assets/Images/VTO/SWATCHES/102-Extraordinary-Swatch.png'
// 23
import shade3 from '../assets/Images/VTO/SWATCHES/103-Better-Not-Pout-Swatch.png'
// 26
import shade4 from '../assets/Images/VTO/SWATCHES/300-Koko-K-Swatch.png'
// 27
import shade5 from '../assets/Images/VTO/SWATCHES/301-Angel-Swatch.png'
// 18
import shade6 from '../assets/Images/VTO/SWATCHES/302-Snow-Way-Bae-Swatch.png'
// 21
import shade7 from '../assets/Images/VTO/SWATCHES/400-Boss-Swatch.png'
// 22
import shade8 from '../assets/Images/VTO/SWATCHES/401-Victoria-Swatch.png'
//28
import shade9 from '../assets/Images/VTO/SWATCHES/402-Mary-Jo-K-Swatch.png'
// 19
import shade10 from '../assets/Images/VTO/SWATCHES/403-Bite-Me-Swatch.png'
// 29
import shade11 from '../assets/Images/VTO/SWATCHES/503-Bad-Lil-Thing-Swatch.png'
// 30
import shade12 from '../assets/Images/VTO/SWATCHES/504-Hollyberry-Swatch.png'
// 31
import shade13 from '../assets/Images/VTO/SWATCHES/505-Autumn-Swatch.png'
// 32
import shade14 from '../assets/Images/VTO/SWATCHES/600-Twenty-Swatch.png'
// 33
import shade15 from '../assets/Images/VTO/SWATCHES/700-Bare-Swatch.png'
// 34
import shade16 from '../assets/Images/VTO/SWATCHES/701-Exposed-Swatch.png'
// 20
import shade17 from '../assets/Images/VTO/SWATCHES/704-Sweater-Weather-Swatch.png'
// 35
import shade18 from '../assets/Images/VTO/SWATCHES/800-One-Wish-Swatch.png'
// 36
import shade19 from '../assets/Images/VTO/SWATCHES/801-Queen-Swatch.png'
// 37
import shade20 from '../assets/Images/VTO/SWATCHES/802-Candy-K-Swatch.png'
// 6
import shade21 from '../assets/Images/VTO/SWATCHES/808-Kylie-Swatch.png'

import {CartWhite, CrossWhiteVTO} from '../components/Icons'
import vtoLogoImage from '../assets/Text/CART/KYLIE_COSMETICS_by_KJ_Logo.png'
import basketImage from '../assets/Icons/BASKET_ICON.png'
import outOfStockImage from '../assets/Icons/OUT_OF_STOCK.png'
import {playClickSound} from '../components/Sound'


import Plausible from 'plausible-tracker'

const { trackEvent } = Plausible({
  domain: 'kylie-world.netlify.app',
  trackLocalhost: true
}) 

let touchStarted = false
let touchStartX = 0

const shadeImages = [null,
                     shade1,
                     shade2,
                     shade3,
                     shade4,
                     shade5,
                     shade6,
                     shade7,
                     shade8,
                     shade9,
                     shade10,
                     shade11,
                     shade12,
                     shade13,
                     shade14,
                     shade15,
                     shade16,
                     shade17,
                     shade18,
                     shade19,
                     shade20,
                     shade21]

const {useState, useEffect, useRef, useCallback} = React

// Props..
// updatePage = {updatePage}
// selectedShade={selectedShade}
// selectShade={selectShade}
// addToCart = {addToCart}/>
// cartContents = {cartContents}

export function VirtualTryOn(props) {

  // work through the (multi-dimentional) array, summing all the items.
  const itemCount = props.cartContents.reduce((a, b) => a + b)

  //updateScene()  // unused as we no longer do a VTO.

  const productIndex = constants.SHADE_PRODUCT_IDS[props.selectedShade]

  const itemInStock = (props.productStock[productIndex] > props.cartContents[productIndex])

  return (
    <>
      <CrossWhiteVTO updatePage={props.updatePage}/>
      <CartWhite updatePage={props.updatePage}
                 itemCount={itemCount}
                 cartIconStatus = {props.cartIconStatus}/>
      <div className='vtoBackground'>
      </div>
      <div className='vtoVisibleScreen'>
        <div className='vtoTopPanel'>
          <img alt="" className='vtoLogoImage' src={vtoLogoImage}/>
        </div>
        <div className='vtoBottomPanel'>
          {<ShadeSelectorBar
            selectedShade={props.selectedShade}
            selectShade={props.selectShade}
            displayWidth={window.innerWidth}
            displayHeight={window.innerHeight * 0.139}
             />}
          {(props.selectedShade === 0) || <AddToCartButton
           addToCart={props.addToCart}
           inStock={itemInStock || props.selectedShade === 0}
           enabled={props.selectedShade !== 0 && itemInStock}/>}
         </div>
      </div>
    </>
  )
}

export function VTODisplay(props) {

    // these map to usable zIndex values.
    const positions = {
      HIDDEN: -1000,
      LAYERED: 0,
      FRONT: 1000
    }

    const [layerPosition, setLayerPosition] = useState(positions.HIDDEN)
    const [consentNotGranted, setConsentNotGranted] = useState(false)
    const [showConsentWarning, setShowConsentWarning] = useState(false)
    const [cameraFailed, setCameraFailed] = useState(false)
    const [showCameraWarning, setShowCameraWarning] = useState(false)
    const [showVtoLoading, setShowVtoLoading] = useState(true)

    const paused = useRef(false)

    const YMK = window.YMK
    const scale = window.innerWidth / 360

    const recordVTOPermissions = (status) => {

      trackEvent("VTO Permissions", {
        callback: () => console.log("plausible track VTO Permissions"),
        props: {
          status: status
        }
      })
    }

    const recordVTOConsent = (status) => {

      trackEvent("VTO Consent", {
        callback: () => console.log("plausible track VTO Consent"),
        props: {
          status: status
        }
      })
    }

    useEffect(() => {
      YMK.open({loadLiveCam: true})

      const cameraOpened = () => {
        setCameraFailed(false)
        recordVTOPermissions(true)
      }
  
      const cameraFailed = () => {

        setCameraFailed(true)

        // if user already exited VTO, no further work to do.
        if (paused.current) return;

        setLayerPosition(positions.HIDDEN)
        setShowCameraWarning(true)
        recordVTOPermissions(false)
      }

      const consentUIShowed = () => {

        setConsentNotGranted(true)
        // if user already exited VTO, no further work to do.
        if (paused.current) return;

        setLayerPosition(positions.FRONT)
      }
      const consentUpdated = (value) => {

        // if user already exited VTO, no work to do.
        if (paused.current) return;

        if (value === "disagree") {
          // user did not give consent
          setShowConsentWarning(true)
          recordVTOConsent(false)
        }
        else {
          // user gave consent
          setConsentNotGranted(false)
          recordVTOConsent(true)
        }
        setLayerPosition(positions.HIDDEN)
      }

      const youCamLoaded = () => {
        // Loaded fires shortly before the image actually appears.
        setTimeout(() => {
          setShowVtoLoading(false)
          setLayerPosition(positions.LAYERED)
        }, 2000)
      }

      // Make sure event listeners aren't added twice...
      YMK.removeEventListener("cameraOpened", cameraOpened)
      YMK.removeEventListener("cameraFailed", cameraFailed)
      YMK.removeEventListener("consentUIShowed", consentUIShowed)
      YMK.removeEventListener("consentUpdated", consentUpdated)
      YMK.removeEventListener("loaded", youCamLoaded)
      
      YMK.addEventListener("cameraOpened", cameraOpened)
      YMK.addEventListener("cameraFailed", cameraFailed)
      YMK.addEventListener("consentUIShowed", consentUIShowed)
      YMK.addEventListener("consentUpdated", consentUpdated)
      YMK.addEventListener("loaded", youCamLoaded)

    },[YMK, positions.HIDDEN, positions.LAYERED, positions.FRONT])

    useEffect(() => {

      // Set active look
      function setLook(shade) {

        if (shade !== 0) {

          const skuId = constants.SKU_CODES[shade]
          const product = constants.SHADE_PRODUCT_IDS[shade]

          console.log("track plausible try on VTO product:", skuId, shade, product)

          trackEvent('Try On VTO Product', {
              callback: () => console.log("done"),
              props: {
                product: constants.PRODUCTS[product].name,
                productTries: PlausibleState.getNumberProductTries(),
                timeInVTO: PlausibleState.getTimeInVTO(),
              }
          })

          YMK.applyMakeupBySku(skuId)
        }
        else {
          YMK.reset()
        }
      }

      setLook(props.shade)
    }, [YMK, props.shade]);

    const restartVTO = useCallback(() => {
      YMK.close()
      YMK.open({loadLiveCam: true})

      // reset layering state.
      setLayerPosition(positions.HIDDEN)
    }, [YMK, positions.HIDDEN])
    
    useEffect(() => {

      paused.current = props.pause

      if (props.pause) {
        YMK.pause()

        // don't show warnings when not in VTO.
        setShowConsentWarning(false)        
        setShowCameraWarning(false)
      }
      else {
        if (!consentNotGranted && !cameraFailed) {
          YMK.resume()
        }
        else {
          // if consent warning shown, need to restart YouCam to re-trigger consent flow.
          restartVTO();
        }
      }
      
    }, [YMK, props.pause, cameraFailed, consentNotGranted, restartVTO]);

    const onConsentWarningContinue = () => {

      setShowConsentWarning(false)
      restartVTO();
    }

    const onCameraWarningContinue = () => {

      setShowCameraWarning(false)
      restartVTO();
    }

    const zIndex = layerPosition;

  return (
    <>
      <div className = 'vtoDisplay' style = {{transform: `scale(${scale})`, zIndex: zIndex}}>
        <div title="Virtual Try On" id="YMK-module">
        </div>
      </div>
      {props.pause || !showConsentWarning || <ConsentWarning continue={onConsentWarningContinue}/>}
      {props.pause || !showCameraWarning || <CameraWarning continue={onCameraWarningContinue}/>}
      {props.pause || !showVtoLoading || showCameraWarning || showCameraWarning || <VtoLoading/>}
    </>
  )
}

function ConsentWarning(props) {

  return (
    <div className= 'consentWarning'>
      <div className='consentText'>
        <p>To virtually try-on the products, please tick the consent form and submit</p>
        <p>If you do not wish to provide consent, the try-on experience will not be available for you to use, please exit this room</p>
      </div>
      <div className='consentButton' onClick={props.continue}>
        Continue
      </div>
    </div>
  )
}

function CameraWarning(props) {

  return (
    <div className= 'consentWarning'>
      <div className='consentText'>
        <p>To virtually try-on the products, you must enable your camera</p>
        <p>If you do not wish to enable your camera, the try-on experience will not be available for you to use, please exit this room</p>
      </div>
      <div className='consentButton' onClick={props.continue}>
        Continue
      </div>
    </div>
  )
}

function VtoLoading(props) {

  const [pipsCounter, setPipsCounter] = useState(0)
  const timerSet = useRef(false);

  useEffect(() => {

    // After 1 second, alternate dark/light every 100msecs.
    if (!timerSet.current) {
        setInterval(() => {       
          setPipsCounter (prev => prev + 1)
        }, 100)
      timerSet.current = true;
    }
  }, []);


  const pips = "....".substring(0, (Math.floor(pipsCounter / 5)) % 4)

  return (
    <div className = 'vtoLoading'>
      <div className ='vtoLoadingText'>
        <p>The experience will begin soon</p>
        <p>To try on the lip kits please accept the camera permission{pips}</p>
      </div>
    </div>
  )
}

function ShadeSelectorBar(props) {

  //console.log("Display Width:", props.displayWidth);

  const shadesCount = constants.SHADES_ARRAY.length;
  const shadesToDisplay = 8; // image sizes means this doesn't work above 9 (they can't be squashed together that tightly)
  const minSwatchWidth = props.displayHeight * 0.6; // Based on aspect ratio of swatch images.
  const shadeDisplayWidth = Math.max(props.displayWidth / shadesToDisplay, minSwatchWidth);
  const totalWidth = (shadesCount) * shadeDisplayWidth;
  const xPosMin = -20;
  const xPosMax = 20 + totalWidth - props.displayWidth;
  const [selectorXPos, setSelectorXPos] = useState(xPosMin);

  function pickShade(shade) {
    // when a shade is picked, we make it the selected shade,
    // and apply it to the VTO
    playClickSound();
    //console.log("Pick shade, shade:", shade);

    if (props.selectedShade === shade) {
      // shade already selected - toggle off.
      props.selectShade(0)
    }
    else {
      props.selectShade(shade)
      
      PlausibleState.recordShadeTriedOn(shade)
    }
  }

  //console.log("selectorXPos", selectorXPos);

  function onTouchStart(event) {
    touchStartX = event.touches[0].pageX
    touchStarted = true
  }

  function onTouchMove(event) {
    if (!touchStarted) {
      return
    }
    var newPos = selectorXPos - (event.touches[0].pageX - touchStartX)

    if (newPos < xPosMin) newPos = xPosMin;
    if (newPos > xPosMax) newPos = xPosMax;

    setSelectorXPos(newPos)

    // record this position as latest touch start
    touchStartX = event.touches[0].pageX
  }

  const trackStyle = {
    position: "absolute",
    overflow: "hidden",
    left: -selectorXPos,
    width : `calc(100% + ${selectorXPos}px)`,
    height: "78%",
    top: "22%"
  }
  const runnerStyle = {
    width: totalWidth,
    height: "100%"
  }

  //console.log("Shade details")
  //console.log(props.selectedShade)
  //console.log(constants.SHADE_PRODUCT_IDS[props.selectedShade]);

  return (
    <div className = 'shadeSelectorBar'>
      <div className='selectedShadeName' >
        {constants.PRODUCTS[constants.SHADE_PRODUCT_IDS[props.selectedShade]].shortName}
      </div>
      <div style = {trackStyle}
        onTouchStart={event => onTouchStart(event)}
        onTouchMove={event => onTouchMove(event)}>
        <div style = {runnerStyle} >
          <div className='shadeSelectorOptions'>
            {constants.SHADES_ARRAY_SHUFFLED.map((item, index) => (
              <ShadeSelector
                    key = {index}
                    shade = {item}
                    selected = {props.selectedShade === item}
                    onClick = {() => pickShade(item)}
                  />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

function ShadeSelector(props) {

  return (
    <div className = 'shadeSelector'
         onClick={props.onClick}>
      <img alt="" className='shadeImage' src={shadeImages[props.shade]}/>
      <div className={props.selected ? 'shadeSelectedCircle' : 'notSelectedCircle'}>
      </div>
    </div>
  )
}

/*function CartIcon(props) {
  return (
    <div className='cartProductBar' onClick={() => props.updatePage(constants.REACT_PAGE_CART)}>
      <img className='cartIconImage' src={EmptyCart}/>
      <div className='cartItemCounter'>{props.itemCount}</div>
    </div>
  )
}*/

function AddToCartButton(props) {
  function clickAddToCart() {

    playClickSound()
    document.getElementById('vtoBasketImage').classList.add('vtoBasketImageClicked')
    document.getElementById('vtoBasketImage').classList.remove('vtoBasketImage')
    setTimeout(() => {
      document.getElementById('vtoBasketImage').classList.add('vtoBasketImage')
      document.getElementById('vtoBasketImage').classList.remove('vtoBasketImageClicked')
    },
    100)

    props.addToCart()
  }

  let image
  if (props.inStock) {
    image = basketImage
  } else {
    image = outOfStockImage
  }

  return (
    <>
      <div
        className='addToCartButton'
        onClick={props.enabled ? () => clickAddToCart() : null}>
        <img alt="" id = 'vtoBasketImage' className='vtoBasketImage' src={image}/>
      </div>
      <div className='addToCartCaption'>
        ADD TO CART
      </div>
    </>
  )
}
